import {Assignee} from './Assignee';
import {tAsString} from '../../../helpers/react/text/tAsString';

export function getAssigneeName(assignee: Assignee): string {
    return assignee.pcc?.code
        ?? assignee.agency?.name
        ?? assignee.agent?.name
        ?? tAsString('N/A');
}
